module.exports = __webpack_public_path__ + "productivity2.png?7b747f5187ded38a80c0122c5effe081";